module.exports = __webpack_public_path__ + "img/Kyrgyz Republic.3bb939c2.gif";